import { createContext, useCallback, useContext, useState } from 'react';

// Create context for product images setting
const ProductImagesContext = createContext<{
  showProductImages: boolean;
  toggleProductImages: () => void;
} | null>(null);

export const useProductImagesContext = () => {
  const context = useContext(ProductImagesContext);
  if (context === null) {
    throw new Error(
      '`useProductImagesContext` must be used within a `<ProductImagesProvider />`',
    );
  }
  return context;
};

export const ProductImagesProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [showProductImages, setShowProductImages] = useState(true);

  const toggleProductImages = useCallback(() => {
    setShowProductImages((prev) => !prev);
  }, []);

  return (
    <ProductImagesContext.Provider
      value={{ showProductImages, toggleProductImages }}
    >
      {children}
    </ProductImagesContext.Provider>
  );
};
